<template>
<div>
  <span class="strip"></span>
  <iframe height="100%" width=200% :src="`${this.path +'?file=' + this.fileName}`" ></iframe>
</div>
</template>

<script>
// import render from '../../../public/web/customToolbar'
export default {
  name: 'PDFJSViewer',
  props: {
    fileName: String,
    path:String
  },
  computed:{ 
    getFilePath: () => {
      if(this.fileName!==''){
          return this.path +'?file=' + this.fileName
      }
      return this.path 
    }
  }
}
</script>
<style scoped>
div {
  width: 50%;
  height: 79vh;
  min-width: 400px;
}
.strip{
       background: #fff;
    padding: 1rem 213rem;
    margin-top: 0rem;
    margin-left: -16rem;
    position: absolute;}
</style>